import { setClassNamePrefix } from 'ui-box'

/** Set the classname for backwards compatibility */
setClassNamePrefix('📦')
